import { VStack } from '@chakra-ui/react';
import { Form, Formik, Field } from 'formik';

import { useForgotPassword } from '@/v5/@hooks/auth/useForgotPassword';
import { forgotPasswordValidationSchema } from '@/v5/validation/authValidation';

import { EmailField } from '@/v5/components/molecules/FormField/EmailField';
import { SubmitButton } from '@/v5/components/atoms/Button/SubmitButton';
import { TcapHeading } from '@/v5/components/atoms/Heading/TcapHeading';
import { TcapLink } from '@/v5/components/atoms/Link/TcapLink';

function ForgotPasswordForm() {
    const { handleSubmit, isLoading, resetMessages } = useForgotPassword();

    const initialValues = {
        email: '',
    };

    return (
        <VStack spacing={4} align="stretch" px="1px">
            <VStack spacing={2} textAlign="center">
                <TcapHeading>Reset your password</TcapHeading>
            </VStack>

            <Formik
                initialValues={initialValues}
                validationSchema={forgotPasswordValidationSchema}
                onSubmit={handleSubmit}>
                {({ isSubmitting }) => (
                    <Form>
                        <VStack spacing={4}>
                            <Field
                                name="email"
                                onFocus={resetMessages}
                                component={EmailField}
                            />

                            <SubmitButton
                                isLoading={isLoading || isSubmitting}
                                loadingText="Sending reset link..."
                                width="full"
                                className="max-h-10">
                                Reset my password
                            </SubmitButton>

                            <TcapLink
                                to="/"
                                state={{ from: '/forgot-password' }}>
                                Back to login
                            </TcapLink>
                        </VStack>
                    </Form>
                )}
            </Formik>
        </VStack>
    );
}

export { ForgotPasswordForm };
